import ComingAppointment from './appointments/coming-appointment.component'
import PastAppointment from './appointments/past-appointment.component'
import AllAppointments from './appointments/all-appointments.component'
import { TFollowup, TPatientFollowup } from 'src/types/followup'

import { TPatientMedEvent } from 'src/types/med-event'
import { TPatientMedAlert } from 'src/types/med-alert'

interface AppointmentsProps {
  currentPatientFollowup?: TPatientFollowup
  patientMedEvents: TPatientMedEvent[]
  patientMedAlerts: TPatientMedAlert[]
  currentFollowup: TFollowup
  patientFollowupId: number
}

const Appointments = ({
  currentPatientFollowup,
  patientMedEvents,
  patientMedAlerts,
  currentFollowup,
  patientFollowupId,
}: AppointmentsProps) => {
  if (currentPatientFollowup?.endReason) {
    return (
      <AllAppointments
        patientMedEvents={patientMedEvents}
        patientMedAlerts={patientMedAlerts}
        currentFollowup={currentFollowup}
        currentPatientFollowupId={patientFollowupId}
      />
    )
  }

  return (
    <>
      {!currentPatientFollowup?.endReason && (
        <ComingAppointment patientMedEvents={patientMedEvents} currentFollowup={currentFollowup} />
      )}
      <PastAppointment
        patientMedEvents={patientMedEvents}
        patientMedAlerts={patientMedAlerts}
        currentFollowup={currentFollowup}
        currentPatientFollowupId={patientFollowupId}
      />
    </>
  )
}

export default Appointments
